import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge26 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='関東エリアのゴルフ会員権相場動向' fontWeight={700} />
                <p>
                    ゴルフ会員権の相場を左右する一般的な要因については
                    <a href='/knowledge/25'>ゴルフ会員権の全国相場データ・価格動向の見方</a>
                    でご紹介しましたが、関東エリアには他のエリアと異なる特徴がいくつかあります。本記事では、関東エリアのゴルフ会員権相場の傾向を整理します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='関東エリアの特徴' fontWeight={700} />

                <Heading3 title='首都圏からの距離でコースの性格が大きく分かれる' />
                <p>
                    関東エリアは、<a href='/courses?prefecture_codes[]=13'>東京都</a>
                    都心から<a href='/courses?prefecture_codes[]=14'>神奈川</a>・
                    <a href='/courses?prefecture_codes[]=11'>埼玉</a>・<a href='/courses?prefecture_codes[]=12'>千葉</a>
                    の近郊、さらに
                    <a href='/courses?prefecture_codes[]=08'>茨城</a>・<a href='/courses?prefecture_codes[]=09'>栃木</a>
                    ・<a href='/courses?prefecture_codes[]=10'>群馬</a>
                    といった郊外まで、ゴルフ場の分布が広範囲にわたります。都心から近く高速道路のアクセスが良いコースは需要が集中しやすい一方、郊外エリアには比較的ゆったりとプレーできるコースも多く、同じ関東エリアの中でも性格が大きく異なります。
                </p>

                <Heading3 title='歴史あるクラブが多く集積している' />
                <p>
                    関東エリアには、戦前から続く歴史ある名門クラブが多く集積しているという特徴があります。こうしたクラブは会員数を厳格に管理していることが多く、入会審査のハードルも相応に高い傾向があります。名門・高額帯クラブ全般の傾向は
                    <a href='/knowledge/30'>名門・高額帯クラブの相場動向</a>
                    でも解説しています。
                </p>

                <Heading3 title='法人需要の存在感が大きい' />
                <p>
                    首都圏には企業の本社機能が集中していることから、接待や社内コミュニケーションを目的とした法人会員権の需要も他エリアと比べて根強く存在します。法人会員権特有の勘定科目・税務処理については
                    <a href='/knowledge/32'>年会費の勘定科目・経費算入の可否</a>
                    もあわせてご参照ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='関東エリアで会員権を検討する際の注意点' fontWeight={700} />
                <p>
                    関東エリアは選択肢が非常に多いため、価格だけで比較するのではなく、自宅・職場からの実際の所要時間、預託金の据置期間、運営会社の経営状況などを総合的に確認したうえで検討することが大切です。特定コースの最新の取引相場については、個別の状況によって大きく異なるため、住地ゴルフまでお気軽にお問合せください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    関東エリアのゴルフ会員権は、都心からの距離やクラブの格式によって相場の性格が大きく異なります。ご希望のエリア・予算に合わせた会員権選びは、豊富な取扱実績を持つ住地ゴルフまでご相談ください。
                    <br />
                    関東エリアのゴルフ場を探す場合は
                    <a href='/courses?area_ids[]=1'>関東エリアのゴルフ場一覧</a>
                    もあわせてご覧ください。
                    <br />
                    全国的な相場の考え方は<a href='/knowledge/25'>こちら</a>、入会にかかる総額の考え方は
                    <a href='/knowledge/13'>こちら</a>もあわせてご確認ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge26;
